import { CustomReportAFY } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React from "react";
import { Filters } from "../resources/reportsSumaries.DTO";
import { buttonActionOptions } from "../../reportsPage/completedSales/completedDTO";

export const ReportsSumariesView = (props: {
  columns: any[];
  rows: any[];
  onBack: () => void;
  reportName: string;
  onChangeFilter?: (data: any) => void;
  onClearFilter?: () => void;
  onExportReport?: (data: buttonActionOptions) => void;
}) => {
  return (
    <React.Fragment>
      <div style={{ width: "calc(100vw - 275px)" }}>
        <CustomReportAFY
          titleButtonBack="Regresar"
          titlePage={props.reportName}
          descriptionPage="Si desea aplicar un filtro al resultado de ventas completadas, seleccione el filtro deseado que se muestra a continuación."
          widthTable={"100%"}
          heightTable={"673px"}
          filters={Filters}
          columnsTable={props.columns}
          rowsTable={props.rows}
          pageSizeTable={11}
          onChangeFilter={props.onChangeFilter}
          onClickBack={props.onBack}
          onClickClearFilters={props.onClearFilter}
          onBlurFullTextSearch={function noRefCheck() {}}
          onChangeFullTextSearch={function noRefCheck() {}}
          onClickExportButton={(e) => {
            props.onExportReport?.(e);
          }}
        />
      </div>
    </React.Fragment>
  );
};
